import { render, staticRenderFns } from "./corporate.vue?vue&type=template&id=593aaa0a&scoped=true&"
import script from "./corporate.vue?vue&type=script&lang=js&"
export * from "./corporate.vue?vue&type=script&lang=js&"
import style0 from "./corporate.vue?vue&type=style&index=0&id=593aaa0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593aaa0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeFaqs: require('/opt/render/project/src/channels2022/src/components/home-page/HomeFaqs.vue').default})
